var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { colors, getFontSize } from '../../../abstracts';
import { createTransition, getStatusColor } from '../utils';
export var HelperText = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", ";\n  padding: 0.25rem 0.75rem;\n  color: ", ";\n  ", "\n"], ["\n  font-size: ", ";\n  padding: 0.25rem 0.75rem;\n  color: ", ";\n  ", "\n"])), getFontSize(1), function (_a) {
    var fieldStatus = _a.fieldStatus;
    return getStatusColor('color')[fieldStatus] || colors.neutralDeeper;
}, createTransition({ properties: ['color'] }));
var templateObject_1;
